<template>
  <div>
	<div class="cgqBox">
		<div class="cgqBoxTil">
			超高分辨率成像·像素再进化
		</div>
		<div class="cgqBoxCen">
			搭载AQ-300系列处理器，可输出超高清分辨率图像，图像质量较之前大大提高
		</div>
		<div class="cgqBoxSp">
			<img src="@/assets/product/page6/sp.png" />
			<!-- <video></video> -->
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.cgqBox{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 150px;
	.cgqBoxTil{
		font-size: 45px;
		
		font-weight: bold;
		color: #000000;
		margin-bottom: 61px;
	}
	.cgqBoxCen{
		font-size: 18px;
		
		font-weight: 300;
		color: #000000;
		margin-bottom: 63px;
	}
	.cgqBoxSp{
		width: 100%;
		height: 600px;
		margin-bottom: 38px;
		img{
			width: 100%;
			height: 100%;
		}
		video{
			width: 100%;
			height: 100%;
		}
	}
	.cgqBoxXiao{
		display: flex;
		overflow-x: auto;
		.cgqBoxFor:not(:last-child){
			margin-right: 40px;
		}
		.cgqBoxFor{
			width: 300px;
			
			.cgqBoxForImg{
				width: 70px;
				height: 70px;
				margin-bottom: 40px;
				img{
					width: 70px;
					height: 70px;
					object-fit: cover;
				}
			}
			.cgqBoxForName{
				font-size: 26px;
				
				font-weight: 400;
				color: #000000;
				margin-bottom: 32px;
			}
			.cgqBoxForCen{
				font-size: 18px;
				
				font-weight: 300;
				color: #000000;
			}
		}
	}
}
</style>
